import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query SearchProjects(
    $title: String
    $country: String
    $state: String
    $tags: [String!]
    $cursor: Cursor
    $limit: Int = 21
    $audience: String
  ) {
    searchProjects(
      title: $title
      country: $country
      state: $state
      cursor: $cursor
      tags: $tags
      limit: $limit
      audience: $audience
    ) {
      items {
        ...ProjectCardFields
        countryCode
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
